window.TeamImportAPI = new function () {

    var self = this;
    var _protected = BaseAPI.call(self);
    var url = environmentsConfig.getEnv().host == environmentsConfig.TEAM_SCHEDULE ? publicConfiguration.TSTeamServerBaseURL : publicConfiguration.TeamServerBaseURL;
    _protected.setApiUrl(url);

    /**
     * Send employees to the team schedule
     * @param brandId
     * @param employees
     * @returns {deferred.promise|{then, always}|{then}}
     */
    self.sendEmployeesToSchedule = function (brandId, employees) {

        var deferred = $q.defer();

        var params = {
            users: employees
        };

        _protected.request("brands/" + brandId + "/team_schedule", "PUT", params)
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (error) {
                deferred.reject(error);
            });

        return deferred.promise;
    };

    self.getHarriBrandEmployees = function (brandId) {

        var deferred = $q.defer();

        _protected.request("brands/" + brandId + "/harri_users", "GET", {})
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (error) {
                deferred.reject(error);
            });

        return deferred.promise;
    };
};